module.exports = __webpack_public_path__ + "img/remilia scarlet_sc2.52e03f3b.png";